<h2 mat-dialog-title style="margin-bottom: 5px">{{dialogTitle}}</h2>
<mat-dialog-content style="overflow: hidden;padding: 10px">
  {{dialogContent}}
</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-right'>
    <tyl-button image="Cancel.png" label="Close" (clickEvent)="cancelClick()"></tyl-button>
  </div>
</mat-dialog-actions>